import "./globals.css";
import { configureAmplify } from "./shared/amplify.js";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App.js";
import { registerSW } from "virtual:pwa-register";
import { toast } from "sonner";
import { startSwUpdatePolling } from "./shared/sw-update.js";

configureAmplify();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

registerSW({
  immediate: true,
  onRegisteredSW(_url, registration) {
    if (registration) startSwUpdatePolling(registration);
  },
});
// autoUpdate swaps the controller in place; offer (never force) a reload —
// an auto-reload mid-cook would be hostile.
let hadController = navigator.serviceWorker?.controller != null;
navigator.serviceWorker?.addEventListener("controllerchange", () => {
  if (!hadController) { hadController = true; return; } // first install, not an update
  toast.info("RecipeVault updated", {
    description: "Reload for the latest version.",
    duration: Number.POSITIVE_INFINITY,
    action: { label: "Reload", onClick: () => { window.location.reload(); } },
  });
});
